import { render } from "./PurchaseReturn.vue?vue&type=template&id=e2edad26&scoped=true"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js"

import "./PurchaseReturn.vue?vue&type=style&index=0&id=e2edad26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2edad26"]])

export default __exports__